import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateUserForm from '../../forms/CreateOrUpdateUserForm'

interface CreateUserModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateUserModal: React.FC<CreateUserModalProps> = ({ open, onClose, loading, error }) => {
  return (
    <AppModal open={open} onClose={onClose} title="Register New User" width="md" loading={loading}>
      <CreateOrUpdateUserForm loading={loading} error={error} />
    </AppModal>
  )
}
export default CreateUserModal
